import { pageScripts } from "./pages";
import { initOpenDialog } from "./pages/helpers";
import { setupLogoutButtons } from "./features/logout"

function toUrl(value = window.location.href) {
    if (value instanceof URL) return value;

    return new URL(String(value), window.location.origin);
}

function pathMatches(pattern, path) {
    const normalizedPattern = pattern.toLowerCase();
    const normalizedPath = path.toLowerCase();

    if (normalizedPattern === normalizedPath) return true;

    if (normalizedPattern.endsWith("/*")) {
        const base = normalizedPattern.slice(0, -2);
        return normalizedPath === base || normalizedPath.startsWith(`${base}/`);
    }

    return false;
}

function initApp(urlLike = window.location.href) {
    const url = toUrl(urlLike);
    const pagePath = url.pathname;

    initOpenDialog();

    Object.entries(pageScripts).forEach(([pattern, initPage]) => {
        if (!pathMatches(pattern, pagePath)) return;
        if (typeof initPage !== "function") return;
        
        initPage({
            url,
            path: pagePath,
            isDialog: false,
        });
    });

    initGlobalFeatures();
}

function initGlobalFeatures() {
    setupLogoutButtons();
}

function handlePageLoad() {
    initApp(window.location.href);
}

function handleDialogOpen(event) {
    const url = event.detail?.url || event.detail?.path || window.location.href;

    const parsedUrl = toUrl(url);

    Object.entries(pageScripts).forEach(([pattern, initPage]) => {
        if (!pathMatches(pattern, parsedUrl.pathname)) return;
        if (typeof initPage !== "function") return;

        initPage({
            url: parsedUrl,
            path: parsedUrl.pathname,
            isDialog: true,
            content: event.detail?.content || null,
            dialogEvent: event,
        });
    });
}

document.addEventListener("DOMContentLoaded", handlePageLoad);
document.addEventListener("dialog:contentready", handleDialogOpen);